var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    stroke: "#003B6F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_137_25228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4494 18.3329C14.6315 18.3055 14.0146 18.1001 13.416 17.817C12.4473 17.3603 11.5882 16.7302 10.7886 16.027C9.70105 15.0681 8.73689 14.0042 7.92809 12.7987C7.462 12.1001 7.05989 11.3695 6.82228 10.5612C6.66692 10.027 6.60294 9.48362 6.75374 8.93111C6.84056 8.61147 7.00963 8.34206 7.24267 8.10919C7.71333 7.64343 8.17941 7.17311 8.6455 6.70279C8.70033 6.648 8.72318 6.65713 8.77344 6.70736C9.7376 7.6754 10.7063 8.63887 11.6751 9.60234C11.7345 9.6617 11.7253 9.6891 11.6705 9.73933C11.145 10.2644 10.6195 10.7896 10.094 11.3101C10.0438 11.3603 10.03 11.3923 10.0803 11.4562C11.0719 12.7667 12.1823 13.9631 13.5531 14.89C13.6217 14.9357 13.6536 14.9357 13.713 14.8763C14.2248 14.3558 14.7457 13.8398 15.2575 13.3192C15.3215 13.2553 15.3535 13.2553 15.4129 13.3192C16.3679 14.2781 17.3275 15.237 18.2871 16.1914C18.3465 16.2507 18.3556 16.2827 18.2917 16.3466C17.8438 16.785 17.396 17.2279 16.9574 17.68C16.4959 18.1549 15.9384 18.3421 15.4494 18.3329Z",
    fill: "#003B6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_137_25228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6659,
    height: 11.6667,
    fill: "white",
    transform: "translate(6.66797 6.6665)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.ca8e69162b4a5bc17e76f862d7955b59.svg";
export { ForwardRef as ReactComponent };